<div class="bulk-edit-toolbar" *ngIf="selectedRowsData && selectedRowsData.length > 0">
    <dx-button text="Bulk Edit Selected Rows" icon="edit" type="default" stylingMode="contained"
        (onClick)="onBulkEditClicked()">
    </dx-button>
    <span class="selected-count">{{ selectedRowsData.length }} row(s) selected</span>
</div>
<app-data-grid id="edit-import-process-routing" [title]='"action_import_process_routing" | translate' [open]="true">

    <dx-data-grid #dataGrid class="dx-card wide-card" [dataSource]="importedProcessRouting" height="60vh"
        [showBorders]="false" [columnAutoWidth]="true" [columnHidingEnabled]="true"
        [editing]="{mode: 'cell', allowUpdating: true}" (onSelectionChanged)="onSelectionChanged($event)"
        (onEditorPreparing)="onEditorPreparing($event)" (onCellPrepared)="onCellPrepared($event)" height="60vh"
        [scrolling]="{ mode: 'standard' }" [keyExpr]="'Id'">

        <!-- <dxo-selection mode="multiple" showCheckBoxesMode="always"></dxo-selection> -->
        <dxo-selection mode="multiple" showCheckBoxesMode="always"></dxo-selection>

        <dxi-column dataField="ErrorMessage" [caption]='"grid_column_error_message" | translate' [allowEditing]="false"
            [visible]="true" cellTemplate="errorMessageTemplate" headerCellTemplate="errorMessageHeaderTemplate">
        </dxi-column>
        <div *dxTemplate="let data of 'errorMessageHeaderTemplate'">
            <div class="custom-header">
                <span class="header-text">{{ 'grid_column_error_message' | translate }}</span>
            </div>
        </div>
        <div *dxTemplate="let data of 'errorMessageTemplate'">
            <div *ngFor="let error of data.data.ErrorMessage">
                {{ error }}
            </div>
        </div>

        <dxi-column dataField="Name" [caption]='"grid_column_name" | translate' [allowEditing]="true" width="100"
            headerCellTemplate="NameHeaderTemplate">
        </dxi-column>
        <div *dxTemplate="let data of 'NameHeaderTemplate'">
            <div class="custom-header">
                <span class="red-asterisk">*</span>
                <span class="header-text">{{ 'grid_column_name' | translate }}</span>
            </div>
        </div>

        <dxi-column dataField="PartName" [caption]='"grid_column_part_name" | translate' [allowEditing]="true"
            headerCellTemplate="PartNameHeaderTemplate" editCellTemplate="partEditorTemplate" [minWidth]="150">
        </dxi-column>
        <div *dxTemplate="let data of 'PartNameHeaderTemplate'">
            <div class="custom-header">
                <span class="red-asterisk">*</span>
                <span class="header-text">{{ 'grid_column_part_name' | translate }}</span>
            </div>
        </div>

        <dxi-column dataField="Type" [caption]='"grid_column_type" | translate' [allowEditing]="true" width="100"
            headerCellTemplate="TypeHeaderTemplate" editCellTemplate="typeEditorTemplate">
        </dxi-column>
        <div *dxTemplate="let data of 'TypeHeaderTemplate'">
            <div class="custom-header">
                <span class="red-asterisk">*</span>
                <span class="header-text">{{ 'grid_column_type' | translate }}</span>
            </div>
        </div>

        <dxi-column dataField="WorkStation" [caption]='"grid_column_workstation" | translate' [allowEditing]="true"
            headerCellTemplate="WorkStationHeaderTemplate" editCellTemplate="workStationEditorTemplate"
            [minWidth]="150">
        </dxi-column>
        <div *dxTemplate="let data of 'WorkStationHeaderTemplate'">
            <div class="custom-header">
                <span class="red-asterisk">*</span>
                <span class="header-text">{{ 'grid_column_workstation' | translate }}</span>
            </div>
        </div>

        <dxi-column dataField="Operation" [caption]='"grid_column_operation" | translate' [allowEditing]="true"
            headerCellTemplate="OperationStationHeaderTemplate">
        </dxi-column>
        <div *dxTemplate="let data of 'OperationStationHeaderTemplate'">
            <div class="custom-header">
                <span class="red-asterisk">*</span>
                <span class="header-text">{{ 'grid_column_operation' | translate }}</span>
            </div>
        </div>

        <dxi-column dataField="Priority" [caption]='"grid_column_priority" | translate' [allowEditing]="true" width="50"
            headerCellTemplate="PriorityHeaderTemplate">
        </dxi-column>
        <div *dxTemplate="let data of 'PriorityHeaderTemplate'">
            <div class="custom-header">
                <span class="red-asterisk">*</span>
                <span class="header-text">{{ 'grid_column_priority' | translate }}</span>
            </div>
        </div>

        <dxi-column dataField="CycleTime" [caption]='"grid_column_cycle_time" | translate' [allowEditing]="true"
            headerCellTemplate="CycleTimeHeaderTemplate">
        </dxi-column>
        <div *dxTemplate="let data of 'CycleTimeHeaderTemplate'">
            <div class="custom-header">
                <span class="red-asterisk">*</span>
                <span class="header-text">{{ 'grid_column_cycle_time' | translate }}</span>
            </div>
        </div>

        <dxi-column dataField="CycleTimePeriodType" [caption]='"grid_column_cycle_time_period_type" | translate'
            [allowEditing]="true" width="100" headerCellTemplate="CycleTimePeriodTypeHeaderTemplate"
            editCellTemplate="cyclePeriodTypeEditorTemplate">
        </dxi-column>
        <div *dxTemplate="let data of 'CycleTimePeriodTypeHeaderTemplate'">
            <div class="custom-header">
                <span class="red-asterisk">*</span>
                <span class="header-text">{{ 'grid_column_cycle_time_period_type' | translate }}</span>
            </div>
        </div>

        <dxi-column dataField="SetupTime" [caption]='"grid_column_setup_time" | translate' [allowEditing]="true"
            headerCellTemplate="SetupTimeHeaderTemplate">
        </dxi-column>
        <div *dxTemplate="let data of 'SetupTimeHeaderTemplate'">
            <div class="custom-header">
                <span class="red-asterisk">*</span>
                <span class="header-text">{{ 'grid_column_setup_time' | translate }}</span>
            </div>
        </div>

        <dxi-column dataField="SetupTimePeriodType" [caption]='"grid_column_setup_time_period_type" | translate'
            [allowEditing]="true" width="100" headerCellTemplate="SetupTimePeriodTypeHeaderTemplate"
            editCellTemplate="setupPeriodTypeEditorTemplate">
        </dxi-column>
        <div *dxTemplate="let data of 'SetupTimePeriodTypeHeaderTemplate'">
            <div class="custom-header">
                <span class="red-asterisk">*</span>
                <span class="header-text">{{ 'grid_column_setup_time_period_type' | translate }}</span>
            </div>
        </div>

        <dxi-column dataField="TotalTime" [caption]='"grid_column_total_time" | translate' [allowEditing]="true"
            headerCellTemplate="TotalTimeHeaderTemplate">
        </dxi-column>
        <div *dxTemplate="let data of 'TotalTimeHeaderTemplate'">
            <div class="custom-header">
                <span class="header-text">{{ 'grid_column_total_time' | translate }}</span>
            </div>
        </div>

        <dxi-column dataField="Quantity" [caption]='"grid_column_quantity" | translate'>
        </dxi-column>

        <dxi-column dataField="Instruction" [caption]='"grid_column_instructions" | translate' [allowEditing]="true"
            type="htmlEditor">
        </dxi-column>
        <!-- <div *dxTemplate="let data of 'InstructionHeaderTemplate'">
        <div class="custom-header">
            <span class="red-asterisk">*</span>
            <span class="header-text">{{ 'grid_column_instructions' | translate }}</span>
        </div>
    </div> -->

        <div *dxTemplate="let cellData of 'workStationEditorTemplate'">
            <dx-select-box [dataSource]="getWorkStationName()" valueExpr="Name" displayExpr="Name"
                [value]="cellData.value" (onValueChanged)="onValueChanged($event, cellData)" [searchEnabled]="true"
                [showClearButton]="true">
            </dx-select-box>
        </div>

        <div *dxTemplate="let cellData of 'partEditorTemplate'">
            <dx-select-box [dataSource]="partDataSource" valueExpr="Name" displayExpr="Name" [value]="cellData.value"
                (onValueChanged)="onValueChangedPart($event, cellData)" [searchEnabled]="true" [showClearButton]="true">
            </dx-select-box>
        </div>

        <div *dxTemplate="let cellData of 'typeEditorTemplate'">
            <dx-select-box [dataSource]="typeDataSource.dataSource" valueExpr="Name" displayExpr="Name"
                [value]="cellData.value" (onValueChanged)="onValueChangedType($event, cellData)" [searchEnabled]="true"
                [showClearButton]="true">
            </dx-select-box>
        </div>

        <div *dxTemplate="let cellData of 'cyclePeriodTypeEditorTemplate'">
            <dx-select-box [dataSource]="cyclePeriodTypeDataSource" valueExpr="Name" displayExpr="Name"
                [value]="cellData.value" (onValueChanged)="onValueChangedCylePeriodType($event, cellData)"
                [searchEnabled]="true" [showClearButton]="true">
            </dx-select-box>
        </div>

        <div *dxTemplate="let cellData of 'setupPeriodTypeEditorTemplate'">
            <dx-select-box [dataSource]="setupPeriodTypeDataSource" valueExpr="Name" displayExpr="Name"
                [value]="cellData.value" (onValueChanged)="onValueChangedSetupPeriodType($event, cellData)"
                [searchEnabled]="true" [showClearButton]="true">
            </dx-select-box>
        </div>


    </dx-data-grid>
</app-data-grid>

<div class="container">
    <div id="save-cancel">
        <dx-button type="danger" [text]="formatText('form_cancel')" icon="close"
            (onClick)="this.onCancelClicked($event)" class="form-button"></dx-button>
        <dx-button id="btn-save" type="success" icon="save" [text]="formatText('form_save')" [disabled]="isSaving"
            (onClick)="this.onSaveClicked($event)" class="form-button"></dx-button>
    </div>
</div>

<!-- ADD START: Bulk Edit popup -->
<dx-popup [(visible)]="bulkEditPopupVisible" [showTitle]="true" [title]="'Bulk Edit Selected Rows'" [width]="500"
    [height]="'auto'" [showCloseButton]="true" [dragEnabled]="false" [shading]="true" [closeOnOutsideClick]="false"
    container=".dx-viewport">
    <div *dxTemplate="let data of 'content'">
        <dx-form>
            <dxi-item itemType="group" caption="Update Fields (leave blank to skip)">
                <dxi-item [label]="{text: formatText('grid_column_name')}">
                    <div *dxTemplate>
                        <dx-text-box [(value)]="bulkEditData.Name" [showClearButton]="true" [maxLength]="nameMaxLength">
                        </dx-text-box>
                    </div>
                </dxi-item>
                <dxi-item [label]="{text: formatText('grid_column_type')}">
                    <div *dxTemplate>
                        <dx-select-box [dataSource]="typeDataSource.dataSource" valueExpr="Name" displayExpr="Name"
                        [(value)]="bulkEditData.Type" [showClearButton]="true" [searchEnabled]="true">
                    </dx-select-box>
                </div>
            </dxi-item>
            <dxi-item [label]="{text: formatText('grid_column_part_name')}">
                <div *dxTemplate>
                    <dx-select-box [dataSource]="partDataSource" valueExpr="Name" displayExpr="Name"
                        [(value)]="bulkEditData.PartName" [showClearButton]="true" [searchEnabled]="true">
                    </dx-select-box>
                </div>
            </dxi-item>
              
                <dxi-item [label]="{text: formatText('grid_column_workstation')}">
                    <div *dxTemplate>
                        <dx-select-box [dataSource]="allWorkStationsWithGroup" valueExpr="Name" displayExpr="Name"
                            [(value)]="bulkEditData.WorkStation" [showClearButton]="true" [searchEnabled]="true">
                        </dx-select-box>
                    </div>
                </dxi-item>

                <dxi-item [label]="{text: formatText('grid_column_cycle_time_period_type')}">
                    <div *dxTemplate>
                        <dx-select-box [dataSource]="cyclePeriodTypeDataSource" valueExpr="Name" displayExpr="Name"
                            [(value)]="bulkEditData.CycleTimePeriodType" [showClearButton]="true"
                            [searchEnabled]="true">
                        </dx-select-box>
                    </div>
                </dxi-item>

                <dxi-item [label]="{text: formatText('grid_column_setup_time_period_type')}">
                    <div *dxTemplate>
                        <dx-select-box [dataSource]="setupPeriodTypeDataSource" valueExpr="Name" displayExpr="Name"
                            [(value)]="bulkEditData.SetupTimePeriodType" [showClearButton]="true"
                            [searchEnabled]="true">
                        </dx-select-box>
                    </div>
                </dxi-item>

            </dxi-item>
        </dx-form>

        <div class="bulk-edit-buttons">
            <dx-button [text]="formatText('form_cancel')" type="danger" icon="close" (onClick)="onBulkEditCancel()"
                class="form-button"></dx-button>
            <dx-button [text]="formatText('form_apply')" type="success" icon="check" (onClick)="onBulkEditApply()"
                class="form-button"></dx-button>
        </div>
    </div>
</dx-popup>
<!-- ADD END -->